<template>
  <b-table-simple :responsive="true" :bordered="bordered">
    <!--  Head  -->
    <b-thead>
      <b-tr>
        <b-th colspan="2">Total</b-th>
      </b-tr>
    </b-thead>
    <!-- end of head    -->
    <b-tbody>
      <b-tr>
        <b-td>
          <strong> X </strong>
        </b-td>
        <b-td> Offday </b-td>
      </b-tr>
      <b-tr>
        <b-td>
          <strong> TOT </strong>
        </b-td>
        <b-td> Total </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
export default {
  name: "TotalSectionExportLegend",
  props: {
    bordered: {
      required: false,
      default: true,
    },
  },
};
</script>

<style scoped></style>
